export function selectActivityDialogItems(groups, status, recordType) {
  if (!status || !recordType) return [];
  const group = groups.find((item) => item.key === status);
  if (recordType === "all") return group?.allCards || group?.cards || [];
  return (group?.cards || []).filter((item) =>
    recordType === "all" || item.reviewEntityType === recordType
  );
}
